import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-planet-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-50">星球漫画</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              致力于为中文读者提供最优质的星际科幻漫画阅读体验，让每一颗热爱漫画的心都能在星海中找到归宿。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">
              <a href="#footer-categories" className="cursor-pointer">漫画分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">
              <a href="#footer-quick" className="cursor-pointer">快捷链接</a>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link></li>
              <li><Link to="/category/kehuan-manhua" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">科幻漫画</Link></li>
              <li><Link to="/category/xingji-manhua" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">星际漫画</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">
              <a href="#footer-contact" className="cursor-pointer">联系我们</a>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </div>
                contact@xingqiumanhua.com
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-wechat-line"></i>
                </div>
                微信公众号：星球漫画
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line"></i>
                </div>
                中国·北京
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 星球漫画 版权所有 | 本站所有漫画均来自互联网，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}